module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<span class=\'network-container\'>\n    <img class=\'network-editor-icon sharing ' +
__e( style ) +
' ' +
__e( state.id ) +
'\'>\n    <span class=\'network-label\'>' +
__e( state.text ) +
'</span>\n</span>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/experience/widgets/socialSharingWidget/SocialSharingWidgetFormatResult.tpl
// module id = 2097
// module chunks = 0